import {
  switzerlandProgram,
} from './szwajcaria-koleja-przez-alpy.js'
import {
  indiaGoldenTriangleProgram,
} from './indie-od-zlotego-trojkata-po-ganges.js'
import {
  maltaVallettaGozoProgram,
} from './malta-miedzy-valletta-a-gozo.js'
import {
  maldivesMaafushiProgram,
} from './malediwy-rajski-reset-na-maafushi.js'
import {
  mexicoYucatanProgram,
} from './meksyk-karaibskie-oblicza-jukatanu.js'
import {
  barcelonaGaudiProgram,
} from './barcelona-miasto-oczami-gaudiego.js'
import {
  ethiopiaElementsProgram,
} from './etiopia-zywioly-polnocy-i-zycie-poludnia.js'
import {
  romeFlorenceProgram,
} from './rzym-i-florencja-sladami-antyku-i-renesansu.js'
import {
  thailandBangkokSouthProgram,
} from './tajlandia-bangkok-i-tropikalne-poludnie.js'
import {
  peruIncaTrailProgram,
} from './peru-droga-inkow-do-machu-picchu.js'
import {
  japanMetropolisNatureProgram,
} from './japonia-w-rytmie-metropolii-i-natury.js'
import {
  newYorkManhattanBrooklynProgram,
} from './nowy-jork-manhattan-i-klimat-brooklynu.js'
import {
  brazilArgentinaIguazuProgram,
} from './brazylia-i-argentyna-miejski-rytm-i-wodospady-iguaz.js'
import {
  madeiraPicoArieiroAtlanticProgram,
} from './madera-z-pico-do-arieiro-nad-atlantyk.js'
import {
  panamaCostaRicaJungleProgram,
} from './panama-i-kostaryka-z-karaibow-w-glab-dzungli.js'
import {
  argentinaChilePatagoniaProgram,
} from './argentyna-i-chile-przez-patagonie-i-ziemie-ognista.js'
import {
  frenchRivieraFourFacesProgram,
} from './lazurowe-wybrzeze-cztery-oblicza-riwiery.js'
import {
  parisSeineMontmartreProgram,
} from './paryz-sekwana-i-uliczki-montmartre.js'
import {
  pakistanKarakoramValleysProgram,
} from './pakistan-dolinami-pod-lodowce-karakorum.js'
import {
  acropolisGreekIslandsProgram,
} from './z-akropolu-ku-greckim-wyspom.js'

const programs = {
  [switzerlandProgram.programKey]:
    switzerlandProgram,
  [indiaGoldenTriangleProgram.programKey]:
    indiaGoldenTriangleProgram,
  [maltaVallettaGozoProgram.programKey]:
    maltaVallettaGozoProgram,
  [maldivesMaafushiProgram.programKey]:
    maldivesMaafushiProgram,
  [mexicoYucatanProgram.programKey]:
    mexicoYucatanProgram,
  [barcelonaGaudiProgram.programKey]:
    barcelonaGaudiProgram,
  [ethiopiaElementsProgram.programKey]:
    ethiopiaElementsProgram,
  [romeFlorenceProgram.programKey]:
    romeFlorenceProgram,
  [thailandBangkokSouthProgram.programKey]:
    thailandBangkokSouthProgram,
  [peruIncaTrailProgram.programKey]:
    peruIncaTrailProgram,
  [japanMetropolisNatureProgram.programKey]:
    japanMetropolisNatureProgram,
  [newYorkManhattanBrooklynProgram.programKey]:
    newYorkManhattanBrooklynProgram,
  [brazilArgentinaIguazuProgram.programKey]:
    brazilArgentinaIguazuProgram,
  [madeiraPicoArieiroAtlanticProgram.programKey]:
    madeiraPicoArieiroAtlanticProgram,
  [panamaCostaRicaJungleProgram.programKey]:
    panamaCostaRicaJungleProgram,
  [argentinaChilePatagoniaProgram.programKey]:
    argentinaChilePatagoniaProgram,
  [frenchRivieraFourFacesProgram.programKey]:
    frenchRivieraFourFacesProgram,
  [parisSeineMontmartreProgram.programKey]:
    parisSeineMontmartreProgram,
  [pakistanKarakoramValleysProgram.programKey]:
    pakistanKarakoramValleysProgram,
  [acropolisGreekIslandsProgram.programKey]:
    acropolisGreekIslandsProgram,
}

/*
 * Kolejność używana przez sortowanie „Polecane”. Aby ją zmienić, wystarczy
 * przesunąć klucz w tej jednej tablicy — bez edytowania wszystkich programów.
 */
export const featuredProgramKeys = [
  'lazurowe-wybrzeze-cztery-oblicza-riwiery',
  'argentyna-i-chile-przez-patagonie-i-ziemie-ognista',
  'panama-i-kostaryka-z-karaibow-w-glab-dzungli',
  'madera-z-pico-do-arieiro-nad-atlantyk',
  'brazylia-i-argentyna-miejski-rytm-i-wodospady-iguazu',
  'nowy-jork-manhattan-i-klimat-brooklynu',
  'paryz-sekwana-i-uliczki-montmartre',
  'pakistan-dolinami-pod-lodowce-karakorum',
  'tajlandia-bangkok-i-tropikalne-poludnie',
  'meksyk-karaibskie-oblicza-jukatanu',
  'malediwy-rajski-reset-na-maafushi',
  'rzym-i-florencja-sladami-antyku-i-renesansu',
  'barcelona-miasto-oczami-gaudiego',
  'japonia-w-rytmie-metropolii-i-natury',
  'peru-machu-picchu-i-tradycje-andow',
  'malta-miedzy-valletta-a-gozo',
  'szwajcaria-koleja-przez-alpy',
  'etiopia-zycie-poludnia-i-gory-bale',
  'indie-od-zlotego-trojkata-po-ganges',
]

/*
 * Stare klucze pozostają aliasami po zmianie nazwy programu. Dzięki temu
 * istniejące osadzenia w WebWave nie przestają działać w chwili aktualizacji.
 */
const programKeyAliases = {
  'etiopia-zywioly-polnocy-i-zycie-poludnia':
    'etiopia-zycie-poludnia-i-gory-bale',
  'peru-droga-inkow-do-machu-picchu':
    'peru-machu-picchu-i-tradycje-andow',
  'brazylia-i-argentyna-miejski-rytm-i-wodospady-iguaz':
    'brazylia-i-argentyna-miejski-rytm-i-wodospady-iguazu',
}

export function getProgramByKey(programKey) {
  const resolvedKey = programKeyAliases[programKey] ?? programKey
  return programs[resolvedKey] ?? null
}

/* Katalog będzie mógł pobrać wszystkie programy z tego samego rejestru. */
export function getAllPrograms() {
  const featuredKeys = new Set(featuredProgramKeys)
  const featuredPrograms = featuredProgramKeys
    .map(programKey => programs[programKey])
    .filter(Boolean)
  const remainingPrograms = Object.values(programs)
    .filter(program => !featuredKeys.has(program.programKey))

  return [...featuredPrograms, ...remainingPrograms]
}
